export const ImageType = {
    SITE_LOGO: 'site-logo',
    PROFILE: 'profile',
    MARKET_BANNER: 'market-banner'
}